<div class="d-inline-flex">
  <ncp-button
    #addMedicalImageButton
    [options]="btnOptions()"
  >
    <img
      [ngSrc]="assets.healthIcons.svg.outline.symbols.diagnostics.src"
      width="18"
      height="18"
      alt="Add Medical Image"
      class="healthIcon"
    />
  </ncp-button>

  <ncp-modal #mod [options]="modOptions()">
    <form
      id="medical_image_form"
      name="medical_image_form"
      [formGroup]="form"
      #frm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-dropdown
        #medicalCenterDD
        [(options)]="medicalCenterOptions"
      />

      <ncp-input [(options)]="authorInputOptions" />

      <ncp-dropdown
        #specialtyDD
        [(options)]="specialtyOptions"
      />

      <ncp-dropdown
        #hospitalizationDD
        [(options)]="hospitalizationOptions"
      />

      <ncp-date
        #onsetDate
        [(options)]="dateOptions"
      />

      <div>
        <label for="documentFile" class="form-label">
          {{ 'input.labels.select_image' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input
          id="documentFile"
          #documentFileInput
          type="file"
          class="form-control"
          accept="image/png,image/jpg,image/jpeg,image/tiff"
          [formControl]="file"
          (change)="onFileSelected($event)"
        />
        @if(documentFileName) {
          <small class="text-muted">
            Selected: {{ documentFileName }}
          </small>
        }
      </div>
    </form>
  </ncp-modal>
</div>
